import RestartAltIcon from '@mui/icons-material/RestartAlt';
import Button, { ButtonProps } from '@mui/material/Button';
import { FC } from 'react';

const ResetButton: FC<ButtonProps> = ({ children = 'Reset', ...rest }) => {
  return (
    <Button
      color="primary"
      startIcon={<RestartAltIcon />}
      variant="outlined"
      {...rest}
    >
      {children}
    </Button>
  );
};

export { ResetButton };
